// /app is a separately built SPA. Use a document navigation and never Next prefetch.
export default function AppLink({ href, children, ...props }) {
  return <a href={href} {...props}>{children}</a>;
}
